function getFlatNewsletterList(newsletterCurationList: InternalNewsletter[]): InternalNewsletter[] {
    const newsletters: InternalNewsletter[] = [];

    function flattenNewsletterList(newsletterList: InternalNewsletter[]): void {
        newsletterList.forEach((newsletter) => {
            if (newsletter.variants) {
                flattenNewsletterList(newsletter.variants);

                return;
            }

            newsletters.push(newsletter);
        });
    }

    flattenNewsletterList(newsletterCurationList);

    return newsletters;
}

export default getFlatNewsletterList;
